export default "__VITE_ASSET__Bu_2$a_3__"